import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Table(theme) {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "separate",
          borderSpacing: 0,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            borderBottom: `2px solid ${theme.palette.grey[200]}`,
            fontWeight: 600,
            fontSize: "0.875rem",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          padding: theme.spacing(2, 1.5),
          fontSize: "0.875rem",
        },
        head: {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.grey[50],
          fontWeight: 600,
        },
        body: {
          color: theme.palette.text.primary,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.04),
          },
          "&:last-child td": {
            borderBottom: 0,
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `1px solid ${theme.palette.grey[200]}`,
          backgroundColor: theme.palette.grey[50],
        },
      },
    },
  };
}
